import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ClientsSection = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClients();
  }, []);

  const loadClients = async () => {
    try {
      const response = await axios.get(`${API}/public/clients`);
      setClients(response.data);
    } catch (error) {
      console.error('Error loading clients:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto"></div>
          </div>
        </div>
      </section>
    );
  }

  if (clients.length === 0) {
    return null;
  }
  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4">
            <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">Clients</span> que confien en nosaltres
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Col·laborem amb institucions públiques, empreses privades i comunitats
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 items-center">
          {clients.map((client) => (
            <div
              key={client._id || client.id}
              className="flex items-center justify-center p-8 bg-white rounded-2xl hover:bg-gradient-to-br hover:from-emerald-50 hover:to-green-50 transition-all duration-300 hover:shadow-xl group border border-slate-100"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="w-full h-auto max-h-16 object-contain opacity-60 group-hover:opacity-100 transition-all duration-300 grayscale group-hover:grayscale-0 group-hover:scale-110"
                title={client.name}
              />
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <p className="text-slate-600 font-medium">
            I molts més clients satisfets a tota Catalunya 🌴
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
